import axios from "axios";
import router from "@/router.js";
import { Message } from 'element-ui'
import { setCookie, getCookie } from 'common/js/mUtils'
/**
 * 提示函数
 * 禁止点击蒙层、显示一秒后关闭
 */
const tip = msg => {
  Message({
    message: msg,
    duration: 1000,
    forbidClick: true
  });
};
/**
 * 跳转登录页
 * 携带当前页面路由，以期在登录页面完成登录后返回当前页面
 */
const toLogin = () => {
  router.replace({
    path: "/login",
    query: {
      redirect: router.currentRoute.fullPath
    }
  });
};
/**
 * 请求失败后的错误统一处理
 * @param {Number} status 请求失败的状态码
 */
const errorHandle = (status, other) => {
  // 状态码的错误
  switch (status) {
    // 401: 未登录 状态，跳转登录页面
    case 401:
      toLogin();
      break;
    case 403:
      tip("登录过期，请重新登录");
      localStorage.removeItem("token");
      /* store.commit('loginSuccess', null) */
      setTimeout(() => {
        toLogin();
      }, 1000);
      break;
    case 404:
      tip("请求的资源不存在");
      break;
    default:
      tip(other);
  }
};

// 创建axios 实例
var instance = axios.create({ tiemout: 1000 * 12 });

//设置post请求头
instance.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded";

// 请求拦截器
instance.interceptors.request.use(
  config => {
    /* 登录流程控制中，根据本地是否存在token判断用户登录情况 但即使token存在 也有可能token是过期的 所以在每次请求头中
      携带token 后台根据token判断用户的登陆情况，并返回给对应的状态码
      而后根据状态码进行一些统一的操作
     */
    /* const token = store.state.token
    token && (config.headers.Authorization = token) */
    return config;
  },
  error => Promise.error(error)
);

/* 响应拦截器 */

instance.interceptors.response.use(
  res => {
    let user_id = getCookie('u_uuid_userId')
    if (user_id) {
      setCookie('u_uuid_userId', user_id, 12)
    } 
    /*else {
      router.replace({
        path: '/login'
      })
    }*/

    return res;
  },
  error => {
    const { response } = error;
    if (response) {
      // 请求已经发送，但是不在2xx的范围
      errorHandle(response.status, response.data.message);
      return Promise.reject(response);
    } else {
      /*
        处理断网情况 例如：请求超时或断网时， 更新 state 的 network状态
        关于断网组件中的刷新重新获取数据，
       */
      // store.commit('changeNetwork', false)
    }
  }
);
export default instance;
